import React from 'react'
import MaximizeIcon from '~/icons/MaximizeIcon'
import CrossedMobileIcon from '~/icons/CrossedMobileIcon'
import { lang, ModuleUI } from 'enablex/shared'
import cx from 'classnames'
import style from './style.scss'

const { SplashScreen } = ModuleUI

const ResolutionOverLay = props => {
  let title
  let description
  let icon
  if (props.device === 'mobile') {
    icon = <CrossedMobileIcon height="100" width="100" />
    title = lang.tr('overlay.mobile.title')
    description = lang.tr('overlay.mobile.optimalResolution')
  } else if (props.device === 'smallDesktopScreen') {
    icon = <MaximizeIcon height="100" width="100" />
    title = lang.tr('overlay.desktop.title')
    let optimalResolution = lang.tr('overlay.desktop.optimalResolution')
    let above = lang.tr('overlay.desktop.above')
    description = (
      <div>
        {optimalResolution}
        <span className="highlight">768x611px</span>
        {above}
      </div>
    )
  }
  return (
    <>
      <main className={cx('overlay-mobile-like', style['overlay-mobile-like'])}>
        <SplashScreen icon={icon} title={title} description={description} />
      </main>
    </>
  )
}

export default ResolutionOverLay
